/*
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-09-17 17:59:40
 */
import React from 'react'
import './HeaderTitle.scss'
interface HeaderTitleProps {
  text: string
}

/**
 * 头部标题组件
 * 支持普通用户和VIP用户的不同渐变效果
 * @param text - 标题文字
 * @param isVip - 是否为VIP用户
 * @param fontSize - 字体大小，默认20px
 * @param className - 额外CSS类名
 */
const HeaderTitle: React.FC<HeaderTitleProps> = ({ text }) => {
  return (
    <div
      className="ai-security-header-title"
      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
    >
      <span style={{ fontSize: '20px' }}>{text}</span>
      <div className="vip-tag">VIP会员专享</div>
    </div>
  )
}

export default HeaderTitle
